import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { api, guardarContexto, guardarToken, temToken } from './api';
import type { Usuario } from './tipos';

interface Contexto {
  usuario: Usuario | null;
  carregando: boolean;
  entrar: (token: string, usuario: Usuario) => void;
  sair: () => void;
  recarregar: () => Promise<void>;
}

const Ctx = createContext<Contexto>(null as unknown as Contexto);

export function ProvedorAuth({ children }: { children: ReactNode }) {
  const [usuario, setUsuario] = useState<Usuario | null>(null);
  const [carregando, setCarregando] = useState(true);

  const recarregar = useCallback(async () => {
    if (!temToken()) {
      setUsuario(null);
      setCarregando(false);
      return;
    }
    try {
      const { usuario } = await api.eu();
      setUsuario(usuario);
    } catch {
      // Token vencido ou acesso revogado. Não adianta insistir nem avisar:
      // a tela volta a ser a de entrada, que é o que a pessoa precisa.
      guardarToken(null);
      setUsuario(null);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { void recarregar(); }, [recarregar]);

  function entrar(token: string, u: Usuario) {
    guardarToken(token);
    setUsuario(u);
  }

  function sair() {
    guardarToken(null);
    guardarContexto(null);
    setUsuario(null);
  }

  return (
    <Ctx.Provider value={{ usuario, carregando, entrar, sair, recarregar }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
